<script>
import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'
import config from '../../actions/config'
import cache from '../../actions/cache'
import {ERROR_LOADING_CONFIG} from '../../utils/messages'
import services from '../../fake/services'
import tours from '../../fake/tours'
import {FAKE_ACTIVE, WS_URL} from '../../utils/config'
import configVettori from '../../fake/configs/vettori'
import configHotels from '../../fake/configs/hotels'
import configServizi from '../../fake/configs/servizi'
import configTours from '../../fake/configs/tours'
import configExperiences from '../../fake/configs/experiences'

export default {
  name: 'ConfigLoader',
  data () {
    return {
      initialized: false
    }
  },
  methods: {
    ...mapGetters(['getTours', 'getToursCodes', 'getServiziCodes']),
    ...mapActions(['resetItinerario', 'resetVariableStep', 'loadingStart', 'loadingEnd']),
    initApp () {
      this.resetItinerario()
      this.resetVariableStep()
      if (!this.initialized) {
        FAKE_ACTIVE ? this.loadAllConfigFake() : this.loadAllConfigReal()
        this.initialized = true
      }
    },
    loadAllConfigReal () {
      config.loadAll().then((values) => {
        const result = values.some((item) => {
          return item === false
        })
        if (result) {
          this.$toastr.error(ERROR_LOADING_CONFIG)
        } else {
          this.loadAllList()
        }
      })
    },
    loadAllConfigFake () {
      this.$store.dispatch(`loadAllVettori`, configVettori)
      this.$store.dispatch(`loadAllHotels`, configHotels)
      this.$store.dispatch(`loadAllServizi`, configServizi)
      this.$store.dispatch(`loadAllTours`, configTours)
      this.$store.dispatch(`loadAllExperiences`, configExperiences)
      this.loadAllListFake()
    },
    loadAllList () {
      this.loadingStart()
      const payload = {question: 'ping'}
      Vue.axios.post(`${WS_URL}ping`, payload, {withCredentials: true}).then(() => {
        const payload = {
          tours: this.getToursCodes(),
          servizi: this.getServiziCodes()
        }
        cache.loadAllList(payload).finally(() => {
          this.loadingEnd()
        })
      }).catch(() => {
        this.$toastr.error('loading error')
        this.loadingEnd()
      })
    },
    loadAllListFake () {
      this.$store.dispatch(`loadTourList`, tours)
      this.$store.dispatch(`loadServiceList`, services)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/loader/MainLoader.vue